import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import ScrollableAnchor from 'react-scrollable-anchor';
import { FileList } from '../../../FileList';

const BodyInformationFieldRead = ({ bodyTextValue, files, onDownloadFile }) => {
  const { t: translator } = useTranslation();

  return (
    <div aria-label={translator('ariaLabel.bodyInformationFieldRead')}>
      <div className="create-hearing-form-field">
        <ScrollableAnchor id="hearingText">
          <div>
            <div>
              <hr className="create-hearing-header-hr" />
              <h2 className="h2-style">
                {translator('hearingProperties.bodyInformation.text')}
              </h2>
              <ReactMarkdown
                source={bodyTextValue || '-'}
                linkTarget="_blank"
              />
            </div>
          </div>
        </ScrollableAnchor>
      </div>
      <FileList
        onDownloadFile={onDownloadFile}
        items={files}
        headerText={translator('hearingProperties.bodyInformation.readMore')}
      />
    </div>
  );
};

export { BodyInformationFieldRead };
